import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'

export interface DashboardStatistics {
  // User statistics
  new_users_count: number
  users_with_ongoing_offers_count: number
  active_applications_count: number
  inactive_applications_count: number
  all_users_count: number

  // Flat statistics
  rented_flats_count: number
  available_flats_count: number
  draft_flats_count: number

  // Payment statistics
  unpaid_user_rents_count: number
  unpaid_landlord_payments_count: number

  // Deposit statistics. Deposits are one-off, so these are running totals
  // rather than the per-month figures the rent summary reports.
  deposits_collected_from_clients: number
  deposits_sent_to_landlords: number
  deposits_held: number
}

export const dashboardStatisticsQueryKey = ['dashboard-statistics']

export function useDashboardStatistics() {
  async function getStatistics(): Promise<DashboardStatistics> {
    const response = await apiClient.get<DashboardStatistics>(
      SNA_PREFIX + 'dashboard/statistics'
    )
    return response.data
  }

  return useQuery({
    queryFn: getStatistics,
    queryKey: dashboardStatisticsQueryKey
  })
}
